import * as THREE from 'three';
import * as packageManager from './Load/PackageManager';
import {RGBELoader} from "three/examples/jsm/loaders/RGBELoader";
import {DragControls} from "three/examples/jsm/controls/DragControls";


export class mainApp {
    appScene;//场景
    appCamera;//相机
    appRenderer;//加载器
    appModel;//模型
    camera;//渲染相机
    appControl;//操作
    // appHotspot;//热点
    appRay;
    appdrag;


    width;//屏幕宽
    height;//屏幕高

    vivwDom;//DOM节点

    constructor(vivwDom) {
        this.vivwDom = vivwDom;
        this.Start();
        this.update();
    }

    //初始化
    Start() {
        this.appScene = new THREE.Scene();
        this.camera = new packageManager.loadCamera().getCamera();
        this.appCamera = new packageManager.loadCamera();
        this.appRenderer = new packageManager.loadRender().getRender();
        this.appModel = new packageManager.loadModel();
        this.appControl = new packageManager.loadControl();
        // this.appHotspot = new packageManager.loadHotspot();
        this.appRay = new packageManager.loadRay();
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.creatScene();
    }

    creatScene() {
        this.camera = this.appCamera.getCamera();
        this.appControl.control(this.camera, this.appRenderer);
        this.vivwDom.appendChild(this.appRenderer.domElement);
        this.appScene.environment = 1;
        // this.appHotspot.bind(this.appScene);
        this.appRenderer.domElement.removeAttribute("tabindex");
        this.handleWindowResize();
        window.addEventListener('resize', this.handleWindowResize.bind(this));

    }

    handleWindowResize() {
        this.appRenderer.setSize(this.vivwDom.clientWidth, this.vivwDom.clientHeight);
        this.camera.aspect = this.vivwDom.clientWidth / this.vivwDom.clientHeight;
        this.camera.updateProjectionMatrix();
    }

    /**
     * 加载模型
     * @param name String 模型名称
     * @param loaded function 加载后的回调
     */
    loadModel(name,func, loaded) {
        let self = this;
        var pmremGenerator = new THREE.PMREMGenerator(self.appRenderer);
        pmremGenerator.compileEquirectangularShader();
        let regeload = new RGBELoader();
        let dataType = regeload.setDataType(THREE.UnsignedByteType);
        let loader = dataType.setPath(`${process.env.BASE_URL}hdr/`);
        loader.load("539992ed6bf9e1.hdr", function (texture) {
            let envMap = pmremGenerator.fromEquirectangular(texture).texture;
            self.appModel.loadModel(name, envMap,func, function (addScene) {
                self.appScene.add(addScene);
                self.appRay.bind(self.camera, self.appScene, self.vivwDom, self.appModel);
            }, loaded);
        })

    }


    /**
     * 是否开启手动拆解
     * @param enable 布尔值 是否开启
     */
    manualSplit(enable) {
        let self = this;
        if(enable){
            self.appdrag = new DragControls(self.appModel.rayMesh, self.camera, self.appRenderer.domElement);
            self.appControl.manualSplit(false);
            self.appdrag.addEventListener('dragstart', function () {
                self.appControl.manualSplit(false);
            });
            self.appdrag.addEventListener('hoveron', function () {
                self.appControl.manualSplit(false);
            });
            self.appdrag.addEventListener('hoveroff', function () {
                self.appControl.manualSplit(true);
            });
            self.appdrag.addEventListener('dragend', function () {
                self.appControl.manualSplit(true);
            })
        }else {
            if(self.appdrag!=null){
                self.appdrag.dispose();
            }

            self.appControl.manualSplit(true);
        }
    }

    /**
     * 一键还原
     */
    oneRestore(){
        this.appModel.oneRestore();
    }
    /**
     * 手动还原
     */
    manualRestore(enable){
        this.appRay.manualRestore(enable);
    }

    /**
     * 显示全部
     */
    showMesh() {
        this.appModel.showMesh();
    }

    /**
     * 半透明
     * @param translucentHide 布尔 是否开启半透明 true 开启 false 关闭
     */
    translucent(translucentHide) {
        this.appModel.translucent(translucentHide);
    }

    /**
     * 是否开启单项隐藏
     * @param individual 布尔 是否开启
     */
    individualHide(individual) {
        this.appRay.heid(individual)
    }

    /**
     * 反向隐藏
     */
    reverseHide() {
        this.appModel.reverseHide();
    }

    /**
     * 自动拆分
     * @param auto 布尔 是否开启动画
     */
    autoDisassemble(auto,restore){
        this.appModel.autoDisassemble(auto,restore);
    }

    autoRotates(enable){
        this.appControl.autoRotates(enable);
    }

    principleMotion(autoAnm){
        this.appModel.principleMotion(autoAnm);
    }




    /**
     * 停止动画
     */
    stopAnimater() {
        this.appModel.stop();
    }

    /**
     * 开始动画
     * @param timeScale 0 关闭 1 开启
     */
    playAnimater(timeScale) {
        this.appModel.play(timeScale);
    }

    clearAnimate() {
        this.appModel.clearAnimate();
    }

    // // 创建一个时钟对象Clock
    // clock = new THREE.Clock();
    // // 设置渲染频率为30FBS，也就是每秒调用渲染器render方法大约30次
    // renderT = 1 / 30; //单位秒  间隔多长时间渲染渲染一次
    // // 如果执行一次renderer.render，timeS重新置0
    // timeS = 0;

    update() {
        requestAnimationFrame(this.update.bind(this));
        // requestAnimationFrame默认调用render函数60次，通过时间判断，降低renderer.render执行频率
            this.appControl.controlUpdate();
            this.appModel.update();
            //this.appHotspot.update();
            this.appRenderer.render(this.appScene, this.camera);
        
    }


    clean() {
        this.appModel.clearCache(this.appScene);
    }


    // createHotspot(name,position,prop,action){
    //     this.appHotspot.createHotspot(name,position,prop,action);
    // }

    // removeHotspot(name){
    //     this.appHotspot.remove(name);
    // }
    // addHotspot(name){
    //     this.appHotspot.add(name);
    // }
    get(name) {
        this.appHotspot.get(name);
    }
}
